import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import TransportationFormLayout from './TransportationFormLayout';

let transportCarrier = null;
function TransportationTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    transportCarrier = props.formFields.R_TRANSPORTCARRIER;
    
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const [forceRender, setForceRender] = useState(false);
    const LoadLookupStaticData = (name, data) => {
        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs.current[name]) {
                formRefs.current[name].instance().option('dataSource', newOptions);
                formRefs.current[name].instance().option('valueExpr', 'id');
                formRefs.current[name].instance().option('displayExpr', 'name');
                setForceRender(!forceRender);
            } else {
            }

        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const LoadLookukpData = (name, url, valueExpr, displayExpr) => {

        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                loadParams:
                {
                    locationTypes: 'Y,D',
                },
                key: valueExpr,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            console.log('found control:');
            formRefs.current[name].instance().option('dataSource', items);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (name == 'TRANSFERTODISPATCH') {
                formRefs.current[name].instance().option('readOnly', false);
            }
            setForceRender(!forceRender);
        } else {
            console.log('not found control:');
        }
    };
    const LoadLookukpLocationData = (name, url, valueExpr, displayExpr, warehouseId) => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                key: valueExpr,
                loadParams: {
                    warehouseRowId: warehouseId,
                    locationTypes: "Y,D"
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            console.log('found control:');
            formRefs.current[name].instance().option('dataSource', items);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            setForceRender(!forceRender);
        } else {
            console.log('not found control:');
        }
    };
    const LoadLookukpWarehouseData = (name, url, valueExpr, displayExpr, locationId) => {

        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                key: valueExpr,
                loadParams: {
                    locationRowId: locationId
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        items.load().then((data) => {
            if (formRefs.current[name]) {
                console.log('found control:');
                formRefs.current[name].instance().option('dataSource', items);
                formRefs.current[name].instance().option('valueExpr', valueExpr);
                formRefs.current[name].instance().option('displayExpr', displayExpr);
                const firstValue = data[0] ? data[0][valueExpr] : null;
                formRefs.current[name].instance().option('value', firstValue);
                setForceRender(!forceRender);
            } else {
                console.log('not found control:');
            }
        }).catch(error => {
            console.error('Error loading data:', error);
        });
    };
    const AdditionalFormLoad = useCallback(() => {
        var transportationModes = [
            { "Rowid": "A", "Code": "Air" },
            { "Rowid": "B", "Code": "Barge" },
            { "Rowid": "O", "Code": "Ocean" },
            { "Rowid": "P", "Code": "Customer Pickup" },
            { "Rowid": "R", "Code": "Rail" },
            { "Rowid": "S", "Code": "Outside Truck" },
            { "Rowid": "T", "Code": "Company Truck" },
            { "Rowid": "C", "Code": "Container" },
            { "Rowid": "L", "Code": "LTL(Less then Truck Load)" },
        ];
        LoadLookupStaticData("TRANSPORTATIONMODE", transportationModes);
        LoadLookukpData("R_EQUIPMENT", "id/Lookup/GetTrucks", 'id', 'name');
        LoadLookukpData("R_CARRIER", "id/Lookup/GetCarrier", 'id', 'name');
        LoadLookukpData("R_DRIVER", "id/Lookup/GetDrivers", 'id', 'name');
        LoadLookukpData("R_AGENT", "id/Lookup/GetAgents", 'id', 'name');
        LoadLookukpData("R_TRANSPORTCARRIER", "id/Lookup/GetCarrier", 'id', 'name');
        LoadLookukpData("EQUIPMENTTYPE", "id/Lookup/GetEquipments", 'name', 'name');
        LoadLookukpData("R_TRAILER", "id/Lookup/GetTrailers", 'id', 'name');
        LoadLookukpData("R_TRANSPORTATIONWAREHOUSE", "id/Lookup/GetWarehouses", 'id', 'name');
        LoadLookukpData("R_TRANSPORTATIONLOCATION", "im/Lookup/GetLocations", 'id', 'name');
        LoadLookukpData("R_CODPAYOR", "wm/Transaction/GetCustomers", 'id', 'name');
        LoadLookukpData("R_CODPAYEE", "wm/Transaction/GetCustomers", 'id', 'name');
        var paymentMethods = [
            { "Rowid": "A", "Code": "Cash" },
            { "Rowid": "C", "Code": "Check" },
            { "Rowid": "N", "Code": "None" },
        ];
        LoadLookupStaticData("CODPAYMETHOD", paymentMethods);
        var fmTransfers = [
            { "Rowid": "B", "Code": "Yes, Create Both FM Dispatch Object & FM Billing Record." },
            { "Rowid": "D", "Code": "Yes, Create FM Dispatch Object" },
            { "Rowid": "N", "Code": "No, FM Interface" },
            { "Rowid": "Y", "Code": "Yes, Create FM Billing Record" },
        ];
        LoadLookupStaticData("TRANSFERTODISPATCH", fmTransfers);
        if (props.formFields.TRANSFERTODISPATCH == "N") {
            formRefs.current['R_FMTRANSACTIONPROFILE'].instance().option('disabled', true);
            formRefs.current['R_FMTRANSACTIONPROFILE'].instance().option('value', null);
        }
        else if (props.formFields.TRANSFERTODISPATCH == "Y") {
            formRefs.current['R_FMTRANSACTIONPROFILE'].instance().option('disabled', false);
            LoadLookukpData("R_FMTRANSACTIONPROFILE", "fm/Lookup/GetFmprofiles", 'id', 'name');
        }
        else {
            formRefs.current['R_FMTRANSACTIONPROFILE'].instance().option('disabled', false);
            LoadLookukpData("R_FMTRANSACTIONPROFILE", "fm/Lookup/GetFmprofilesdispatch", 'id', 'name');
        }



        if(props.isCommittedTransaction){
            if (formRefs.current) {
                Object.keys(formRefs.current).forEach((key) => {
                    //if (key === "REFERENCE" || key === "COMMENT") return;
                    const instance = formRefs.current[key]?.instance;
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                    }
                });
            }
        }



    }, []);
    const handleFieldChange = useCallback((name, value, e) => {
        
        if (name == 'R_CARRIER') {
            const transactionType = props.formRefs.current['TRANSACTIONTYPE'].instance().option('value');
            const customer = props.formRefs.current['R_CUSTOMER'].instance().option('value');
            const shipper = props.formRefs.current['R_SHIPPER'].instance().option('value');
            const consignee = props.formRefs.current['R_CONSIGNEE'].instance().option('value');
            const transportationMode = formRefs.current['TRANSPORTATIONMODE'].instance().option('value');
            const carrier = value;
            if (transactionType === "S") {
                if (customer && shipper && consignee && (transportationMode && transportationMode === "R")) {
                    props.GetShippingInfo(customer,
                        shipper,consignee,carrier);
                }
            }
        }
        if (name == 'R_CARRIER' && (transportCarrier == null || transportCarrier == undefined || transportCarrier == '')) {
            formRefs.current['R_TRANSPORTCARRIER'].instance().option('value', value);
            props.setformFields(prevFields => ({
                ...prevFields,
                R_TRANSPORTCARRIER: value,
            }));
            transportCarrier = value;
        }
        if (name == 'TRANSFERTODISPATCH') {
            if (formRefs.current['R_FMTRANSACTIONPROFILE']) {
                console.log('found control:');
                if (value == "N") {
                    formRefs.current['R_FMTRANSACTIONPROFILE'].instance().option('disabled', true);
                    formRefs.current['R_FMTRANSACTIONPROFILE'].instance().option('value', null);
                }
                else if (value == "Y") {
                    formRefs.current['R_FMTRANSACTIONPROFILE'].instance().option('disabled', false);
                    props.setformFields(prevFields => ({
                        ...prevFields,
                        R_FMTRANSACTIONPROFILE: "",
                    }));
                    LoadLookukpData("R_FMTRANSACTIONPROFILE", "fm/Lookup/GetFmprofiles", 'id', 'name');
                }
                else {
                    formRefs.current['R_FMTRANSACTIONPROFILE'].instance().option('disabled', false);
                    props.setformFields(prevFields => ({
                        ...prevFields,
                        R_FMTRANSACTIONPROFILE: "",
                    }));
                    LoadLookukpData("R_FMTRANSACTIONPROFILE", "fm/Lookup/GetFmprofilesdispatch", 'id', 'name');
                }
                setForceRender(!forceRender);
            }
        }
        if (name == 'R_TRANSPORTATIONWAREHOUSE') {
            LoadLookukpLocationData("R_TRANSPORTATIONLOCATION", "im/Lookup/GetLocations", 'id', 'name', value);
        }
        if (name == 'R_TRANSPORTATIONLOCATION') {
            LoadLookukpWarehouseData("R_TRANSPORTATIONWAREHOUSE", "id/Lookup/GetWarehouses", 'id', 'name', value);
        }
    }, []);
    const handleSelectionChange = useCallback((name, e) => {
        if (name == 'R_CARRIER' && e.selectedItem) {
            let fields = props.formFields;
            fields.Carrier.SCACCODE = e.selectedItem.code;
            props.setformFields(fields);
        }
    }, []);
    return (
        <div>
            <div>
                <FormField
                    currrentUser={currentUser}
                    layoutId='F1E9B642-BF91-4089-8C45-E8C98FB88B5F'
                    layoutName='MyTestForm'
                    defaultFormSchema={TransportationFormLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    handleSelectedItemChange={handleSelectionChange}
                    formRefs={formRefs}
                    onFormLoad={AdditionalFormLoad}
                    noSpacingBeforeFirstRow={true}
                />
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransportationTab);